export default __webpack_public_path__ + "static/media/bv-product-limited.6c470ab8.png";